export default __webpack_public_path__ + "media/images/svg/line-19351240fedc9cf584e71702b45f5749.svg";